import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import PayoutList from "./components/PayoutList";
import AddBatchFile from "./components/AddBatchFile";
import { getClientRegularPayout } from "api/graphQL_crypto";
import { getAllGatewaysSecond } from "api/graphQL_gateways";

export interface PayoutRowObj {
  id: any; createdAt: any; batchId: any; clientId: any;
  clientName: any; gatewayId: any; gatewayName: any;
  totalTransactions: any; gateway: any; totalAmount: any;
  currency: any; transations: any; type: any;
}

const BatchPayout = (props:{client_id:any}) => {
  const { client_id } = props;
  const [page, setPage] = useState<number>(1);
  const [payouts, setPayouts] = useState<PayoutRowObj[]>([]);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { singleRoleData } = useContext(ClientContext);
  const location = useLocation();
  const [localFilters, setLocalFilters] = useState<any>({});

  const [allOrgDetails, setAllOrgDetails] = useState<any>();

  const [filter, setFilter] = useState({
    clients: [] , gateways: [] , dates: null
  });

  const [clearClicked, setClearClick] = useState(0);  

  const fetchPayouts = () => {
    let finalSearchText = "";
    if (location.state?.search) {
      finalSearchText = location.state.search;
      window.history.replaceState({}, document.title);
    } else {
      finalSearchText = searchTexts;
    }
    if (pageSize === null || pageSize === undefined) { setIsLoading(false); return; }
    setIsLoading(true);
    getClientRegularPayout({ page, per_page: pageSize,client_id:client_id, searchTexts: finalSearchText,filter:filter })
      .then((data: any) => {
        if (data.status === "Error") {
          setPayouts([]); setTotalPage(1); setTotalItems(0); setCurrentPage(1);
        } else {
          setPayouts(data?.[0]);
          setTotalPage(data?.[1].total_pages);
          setTotalItems(data?.[1].total_items);
          setCurrentPage(data?.[1].current_page);
        }
      })
      .catch(() => { setPayouts([]); })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => { fetchPayouts(); }, [page, pageSize, searchTexts, clearClicked]);
  useEffect(() => { setPageSize(50); }, [searchTexts]);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt); setPage(1); setCurrentPage(1);
    } else { await setSearchTexts(search_txt); }
  };

  const onClearClick = () => setClearClick((prev) => prev + 1);

  const fecthOrgData = () => {
  
      getAllGatewaysSecond()
        .then((data) => {
          setAllOrgDetails(
            data?.map((gateway: any) => ({
              ...gateway,
              label: gateway?.name,
              value: gateway?.id,
            }))
          );
        })
        .catch(() => {});
    };

    const filterData = () => {
      let finalSearchText = "";
      if (location.state?.search) {
        finalSearchText = location.state.search;
        window.history.replaceState({}, document.title);
      } else {
        finalSearchText = searchTexts;
      }
      if (pageSize === null || pageSize === undefined) { setIsLoading(false); return; }
      setIsLoading(true);
      getClientRegularPayout({ page, per_page: pageSize, searchTexts: finalSearchText,filter:filter })
        .then((data: any) => {
          if (data.status === "Error") {
            setPayouts([]); setTotalPage(1); setTotalItems(0); setCurrentPage(1);
          } else {
            setPayouts(data?.[0]);
            setTotalPage(data?.[1].total_pages);
            setTotalItems(data?.[1].total_items);
            setCurrentPage(data?.[1].current_page);
          }
        })
        .catch(() => { setPayouts([]); })
        .finally(() => setIsLoading(false));
    }
  
    useEffect(() => {
        fecthOrgData();
      }, []);

  return (
    <div className="bp-root">
      <PayoutList
        tableData={payouts}
        fetchPayouts={fetchPayouts}
        isLoading={isLoading}
        roleData={singleRoleData}
        onValueChange={serchboxValueChange}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        setLocalFilters={setLocalFilters}
        filterData={filterData}
        localFilters={localFilters}
        filter={filter}
        setFilter={setFilter}
        setClearClick={onClearClick}
        allOrgDetails={allOrgDetails}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .bp-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex; flex-direction: column; gap: 20px;
        }
      `}</style>
    </div>
  );
};

export default BatchPayout;